import React from "react";

import "./productFacing.scss";

type Props = {
    layer: string;
    subFacingName: string;
    name: string;
    position: string;
    amountOfPositions: string;
};

const ProductFacing = ({
    layer,
    subFacingName,
    name,
    position,
    amountOfPositions,
}: Props) => {
    return (
        <div
            className={"product-facing border border-dark border-width-3 p-2"}
        >{`${layer} - ${subFacingName} (${name} ${position}/${amountOfPositions})`}</div>
    );
};

export default ProductFacing;
